export const CONFIGURATION = {
  GET_SEEDLIST_BY_CLIENTID: "GET_SEEDLIST_BY_CLIENTID",
  GET_TESTLIST_BY_CLIENTID: "GET_TESTLIST_BY_CLIENTID",
  GET_TRACKINGPARAMETER_BY_CLIENTID: "GET_TRACKINGPARAMETER_BY_CLIENTID",
  GET_FROMEMAIL_BY_CLIENTID: "GET_FROMEMAIL_BY_CLIENTID",
  GET_TOEMAIL_BY_CLIENTID: "GET_TOEMAIL_BY_CLIENTID",
  GET_FROMNAME_BY_CLIENTID: "GET_FROMNAME_BY_CLIENTID",
  GET_SEEDLIST_FROM_CONFIGURATIONLIST: "GET_SEEDLIST_FROM_CONFIGURATIONLIST",
  GET_TESTLIST_FROM_CONFIGURATIONLIST: "GET_TESTLIST_FROM_CONFIGURATIONLIST",
  GET_SMS_SEEDLIST_FROM_CONFIGURATIONLIST:
    "GET_SMS_SEEDLIST_FROM_CONFIGURATIONLIST",
  GET_SMS_TESTLIST_FROM_CONFIGURATIONLIST:
    "GET_SMS_TESTLIST_FROM_CONFIGURATIONLIST",
  GET_EMAILCONFIGFORM_BY_CLIENTID: "GET_EMAILCONFIGFORM_BY_CLIENTID",
  GET_SMSCONFIGFORM_BY_CLIENTID: "GET_SMSCONFIGFORM_BY_CLIENTID",
  GET_SMS_PHONENUMBERS_BY_CLIENTID: "GET_SMS_PHONENUMBERS_BY_CLIENTID",
  GET_SMS_SMART_ENCODING_STATUS: "GET_SMS_SMART_ENCODING_STATUS",
  GET_CONFIGURATION_INTEGRATIONLIST_BY_CLIENTID:
    "GET_CONFIGURATION_INTEGRATIONLIST_BY_CLIENTID",
  GET_CONFIGURATION_INTEGRATIONLIST_BY_PROVIDER_CATEGORIES:
    "GET_CONFIGURATION_INTEGRATIONLIST_BY_PROVIDER_CATEGORIES",
  GET_CONFIGURATION_PROVIDER_CATEGORIES:
    "GET_CONFIGURATION_PROVIDER_CATEGORIES",
  GET_CONFIGURATION_INTEGRATIONPARAMS_BYPROVIDEID:
    "GET_CONFIGURATION_INTEGRATIONPARAMS_BYPROVIDEID",
  GET_APPENDTRACKINGPARAMS_BY_CLIENTID: "GET_APPENDTRACKINGPARAMS_BY_CLIENTID",
  GET_PROVIDER_BYCLIENTID: "GET_PROVIDER_BYCLIENTID",
  GET_DataIntegration_LOG: "GET_DataIntegration_LOG",
  IS_LOADING: "IS_LOADING",
  IS_GRIDLOADING: "IS_GRIDLOADING",
  GET_MENU_BY_CLIENTID: "GET_MENU_BY_CLIENTID",
  GET_ACCOUNT_MANAGERS: "GET_ACCOUNT_MANAGERS",
  GET_CLIENT_SETTINGS: "GET_CLIENT_SETTINGS",
  SHOW_WELCOME_POPUP: "SHOW_WELCOME_POPUP",

  SMS_GET_SEEDLIST_BY_CLIENTID: "SMS_GET_SEEDLIST_BY_CLIENTID",
  SMS_GET_TESTLIST_BY_CLIENTID: "SMS_GET_TESTLIST_BY_CLIENTID",
  SMS_GET_FROMEMAIL_BY_CLIENTID: "SMS_GET_FROMEMAIL_BY_CLIENTID",
  SMS_GET_HELPEMAIL_BY_CLIENTID: "SMS_GET_HELPEMAIL_BY_CLIENTID",
  SMS_GET_FROMNAME_BY_CLIENTID: "SMS_GET_FROMNAME_BY_CLIENTID",

  // Premium Integration Wizard
  GET_PROVIDER_METADATA_REQUEST: "GET_PROVIDER_METADATA_REQUEST",
  GET_PROVIDER_METADATA_SUCCESS: "GET_PROVIDER_METADATA_SUCCESS",
  GET_PROVIDER_METADATA_ERROR: "GET_PROVIDER_METADATA_ERROR",
  TEST_CONNECTION_REQUEST: "TEST_CONNECTION_REQUEST",
  TEST_CONNECTION_SUCCESS: "TEST_CONNECTION_SUCCESS",
  TEST_CONNECTION_ERROR: "TEST_CONNECTION_ERROR",
  CLEAR_PROVIDER_METADATA: "CLEAR_PROVIDER_METADATA",
  CLEAR_TEST_CONNECTION_RESULT: "CLEAR_TEST_CONNECTION_RESULT",
};

export const USERMANAGEMENT = {
  GET_COMPANIES: "GET_COMPANIES",
  GET_USERS_BY_CLIENT: "GET_USERS_BY_CLIENT",
  GET_USER_BY_USER_ID: "GET_USER_BY_USER_ID",
  ADD_USER: "ADD_USER",
  UPDATE_USER: "UPDATE_USER",
  CHECK_USER_PASSWORD: "CHECK_USER_PASSWORD",
  CLIENT_ROLES: "CLIENT_ROLES",
  GET_MANAGE_COLUMNS: "GET_MANAGE_COLUMNS",
  GET_USER_TRUSTED_DEVICES: "GET_USER_TRUSTED_DEVICES",
};

export const PROCESSINGITEMS = {
    GET_PROCESSING_ITEMS: "GET_PROCESSING_ITEMS",
};

export const CONTACTABILITY = {
  UPDATE_COUNT_BY_SPAM_LAW: "UPDATE_COUNT_BY_SPAM_LAW",
  HIGHEST_SPAM_LAW_AUTHORITY: "HIGHEST_SPAM_LAW_AUTHORITY",
  UPDATE_RECENT_EMAIL_SENDS: "UPDATE_RECENT_EMAIL_SENDS",
  UPDATE_ADRESSABLE_PEOPLE_DATA: "UPDATE_ADRESSABLE_PEOPLE_DATA",
  UPDATE_CONSENT_DATA: "UPDATE_CONSENT_DATA",
  EXPLICIT_EMAIL_PERMISSION_COUNT: "EXPLICIT_EMAIL_PERMISSION_COUNT",
  UPDATE_CLICK_OVER_TIME: "UPDATE_CLICK_OVER_TIME",
  UPDATE_OPEN_OVER_TIME: "UPDATE_OPEN_OVER_TIME",
  UPDATE_BOUNCE_OVER_TIME: "UPDATE_BOUNCE_OVER_TIME",
  UPDATE_UNSUBSCRIBES_OVER_TIME: "UPDATE_UNSUBSCRIBES_OVER_TIME",
  UPDATE_ADRESS_CERTIFICATION_SUMMARY: "UPDATE_ADRESS_CERTIFICATION_SUMMARY",
  UPDATE_EMAIL_SUBSCRIBER_ENGAGEMENT_SUMMARY:
    "UPDATE_EMAIL_SUBSCRIBER_ENGAGEMENT_SUMMARY",
  UPDATE_EMAIL_STATUS_SUMMARY: "UPDATE_EMAIL_STATUS_SUMMARY",
};

export const DATABASEOVERVIEW = {
  DETAIL_CHART: "DETAIL_CHART",
  AVERAGE_OPEN_RATE_SUMMARY_UPDATE: "AVERAGE_OPEN_RATE_SUMMARY_UPDATE",
  PEOPLE_RECENTLY_EMAILED_SUMMARY_UPDATE:
    "PEOPLE_RECENTLY_EMAILED_SUMMARY_UPDATE",
  REVENUE_DRIVEN_BY_TOP_CUSTOMERS_SUMMARY_UPDATE:
    "REVENUE_DRIVEN_BY_TOP_CUSTOMERS_SUMMARY_UPDATE",
  RECENT_CUSTOMER_SUMMARY_UPDATE: "RECENT_CUSTOMER_SUMMARY_UPDATE",
  EMAIL_ENGAGEMENT_SUMMARY_UPDATE: "EMAIL_ENGAGEMENT_SUMMARY_UPDATE",
  PEOPLE_COUNT_SUMMARY_UPDATE: "PEOPLE_COUNT_SUMMARY_UPDATE",
  AVERAGE_ORDER_VALUE_SUMMARY_UPDATE: "AVERAGE_ORDER_VALUE_SUMMARY_UPDATE",
  ATTRIBUTED_REVENUE_SUMMARY_UPDATE: "ATTRIBUTED_REVENUE_SUMMARY_UPDATE",
  ATTRIBUTED_REVENUE_DETAIL_UPDATE: "ATTRIBUTED_REVENUE_DETAIL_UPDATE",
  PEOPLE_WITH_EMAIL_SUMMARY_UPDATE: "PEOPLE_WITH_EMAIL_SUMMARY_UPDATE",
  SUMMARY_PEOPLE_WITH_EMAIL_DETAIL_UPDATE:
    "SUMMARY_PEOPLE_WITH_EMAIL_DETAIL_UPDATE",
  SUMMARY_EMAIL_ENGAGEMENT_DETAIL_UPDATE:
    "SUMMARY_EMAIL_ENGAGEMENT_DETAIL_UPDATE",
  SUMMARY_RECENT_CUSTOMERS_DETAIL_UPDATE:
    "SUMMARY_RECENT_CUSTOMERS_DETAIL_UPDATE",
  SUMMARY_REVENUE_TOP_CUSTOMER_DETAIL_UPDATE:
    "SUMMARY_REVENUE_TOP_CUSTOMER_DETAIL_UPDATE",
  SUMMARY_PEOPLE_RECENT_EMAIL_DETAIL_UPDATE:
    "SUMMARY_PEOPLE_RECENT_EMAIL_DETAIL_UPDATE",
  SUMMARY_AVERAGE_OPEN_RATE_DETAIL_UPDATE:
    "SUMMARY_AVERAGE_OPEN_RATE_DETAIL_UPDATE",
  UPDATE_DATABASE_GROWTH_DATABASE: "UPDATE_DATABASE_GROWTH_DATABASE",
  UPDATE_DATABASE_GROWTH_CUMULATIVE: "UPDATE_DATABASE_GROWTH_CUMULATIVE",
  SUMMARY_PEOPLE_DETAIL_UPDATE: "SUMMARY_PEOPLE_DETAIL_UPDATE",
  SUMMARY_AVERAGE_ORDER_VALUE_DETAIL_UPDATE:
    "SUMMARY_AVERAGE_ORDER_VALUE_DETAIL_UPDATE",
  SUMMARY_HIGHEST_AVERAGE_ORDER_VALUE_DETAIL_UPDATE:
    "SUMMARY_HIGHEST_AVERAGE_ORDER_VALUE_DETAIL_UPDATE",
};

export const DATAQUALITY = {
  UPDATE_TOP_10_CUSTOMERS_TAB: "UPDATE_TOP_10_CUSTOMERS_TAB",
  UPDATE_TOP_10_CUSTOMERS_DATA_TABLE: "UPDATE_TOP_10_CUSTOMERS_DATA_TABLE",
  UPDATE_POSTAL_MULTIPLE_LTGIDS_DATA_TABLE:
    "UPDATE_POSTAL_MULTIPLE_LTGIDS_DATA_TABLE",
  UPDATE_EMAIL_MULTIPLE_LTGIDS_DATA_TABLE:
    "UPDATE_EMAIL_MULTIPLE_LTGIDS_DATA_TABLE",
  UPDATE_PHONE_MULTIPLE_LTGIDS_DATA_TABLE:
    "UPDATE_PHONE_MULTIPLE_LTGIDS_DATA_TABLE",
  UPDATE_OVERALL_DB_QUALITY_SCORE_DATA: "UPDATE_OVERALL_DB_QUALITY_SCORE_DATA",
  UPDATE_DB_QUALITY_BY_FIRST_SCORE_DATA:
    "UPDATE_DB_QUALITY_BY_FIRST_SCORE_DATA",
  UPDATE_DATA_QUALITY_DATA_TABLE: "UPDATE_DATA_QUALITY_DATA_TABLE",
  UPDATE_CASS_REPORT_DATA_TABLE: "UPDATE_CASS_REPORT_DATA_TABLE",
};

export const DATASOURCE = {
  REVENUE_PERCENTAGE_BY_SOURCES_UPDATE: "REVENUE_PERCENTAGE_BY_SOURCES_UPDATE",
  DATABASE_PERCENTAGE_BY_SOURCES_UPDATE:
    "DATABASE_PERCENTAGE_BY_SOURCES_UPDATE",
  CUSTOMER_PERCENTAGE_BY_SOURCES_UPDATE:
    "CUSTOMER_PERCENTAGE_BY_SOURCES_UPDATE",
  PEOPLE_PERCENTAGE_BY_SOURCES_UPDATE: "PEOPLE_PERCENTAGE_BY_SOURCES_UPDATE",
  UPDATE_DATASOURCES_VENN_DIAGRAM_DATA: "UPDATE_DATASOURCES_VENN_DIAGRAM_DATA",
  LOAD_DATA_SOURCES_LIST: "LOAD_DATA_SOURCES_LIST",
  UPDATE_LIFE_VALUE_BY_LAST_SOURCE: "UPDATE_LIFE_VALUE_BY_LAST_SOURCE",
  UPDATE_PEOPLE_BY_FIRST_SOURCE: "UPDATE_PEOPLE_BY_FIRST_SOURCE",
  UPDATE_PEOPLE_BY_LAST_SOURCE: "UPDATE_PEOPLE_BY_LAST_SOURCE",
  UPDATE_LIFE_VALUE_BY_FIRST_SOURCE: "UPDATE_LIFE_VALUE_BY_FIRST_SOURCE",
  UPDATE_DATASOURCES_TABLE_DATA: "UPDATE_DATASOURCES_TABLE_DATA",
};

export const DATADICTIONARY = {
  GET_TABLE_DATA: "GET_TABLE_DATA",
  GET_BATCH_DATA: "GET_BATCH_DATA",
  GET_ATTRIBUTES: "GET_ATTRIBUTES",
  GET_DETAILS: "GET_DETAILS",
};

export const PREFERENCECENTER = {
  GET_TABLE_DATA: "GET_TABLE_DATA",
  ADD_UPDATE_GROUPS: "ADD_UPDATE_GROUPS",
  GET_AUDIENCE_BY_FIELD_DATA: "GET_AUDIENCE_BY_FIELD_DATA",
};

export const DEMPOGRAPHIC = {
  UPDATE_AGE_RANGE: "UPDATE_AGE_RANGE",
  UPDATE_CHILDREN_IN_HOUSEHOLD: "UPDATE_CHILDREN_IN_HOUSEHOLD",
  UPDATE_MARITAL_STATUS: "UPDATE_MARITAL_STATUS",
  UPDATE_INCOME_RANGE: "UPDATE_INCOME_RANGE",
  UPDATE_OCUPATION: "UPDATE_OCUPATION",
  UPDATE_EDUCATION: "UPDATE_EDUCATION",
  UPDATE_GENDER: "UPDATE_GENDER",
};

export const FILEMANAGEMENT = {
  IS_FILE_UPLOAD_VALID: "IS_FILE_UPLOAD_VALID",
  LOAD_FILE_MANAGEMENT_DATA: "LOAD_FILE_MANAGEMENT_DATA",
  DELETE_FILE: "DELETE_FILE",
  ADD_DIRECTORY: "ADD_DIRECTORY",
  UPLOAD: "UPLOAD",
  RENAME: "RENAME",
  FILE_UPLOAD_BY_CHUNKS_COMPLETE: "FILE_UPLOAD_BY_CHUNKS_COMPLETE",
  REMOVE_FILE_UPLOAD_CHUNKS_STATE: "REMOVE_FILE_UPLOAD_CHUNKS_STATE",
  FILE_MANAGEMENT_CONFIGURATIONS: "FILE_MANAGEMENT_CONFIGURATIONS",
  VALIDATE_DOWNLOAD: "VALIDATE_DOWNLOAD",
  FILE_MANAGEMENT_GET_ROOT_FOLDERS: "FILE_MANAGEMENT_GET_ROOT_FOLDERS",
  FILE_MANAGEMENT_GET_FOLDERS: "FILE_MANAGEMENT_GET_FOLDERS",
  FILE_MANAGEMENT_GET_FOLDER_STRUCTURE: "FILE_MANAGEMENT_GET_FOLDER_STRUCTURE",
  LOAD_FILE_MANAGEMENT_TREE_DATA: "LOAD_FILE_MANAGEMENT_TREE_DATA",
};

export const GEOGRAPHY = {
  UPDATE_HEAT_MAP_DATA: "UPDATE_HEAT_MAP_DATA",
  UPDATE_STATE_DATA: "UPDATE_STATE_DATA",
  UPDATE_METRO_STATE_DATA: "UPDATE_METRO_STATE_DATA",
  UPDATE_STATE_HEAT_MAP_DATA: "UPDATE_STATE_HEAT_MAP_DATA",
  UPDATE_METRO_HEAT_MAP_DATA: "UPDATE_METRO_HEAT_MAP_DATA",
};

export const RFM = {
  UPDATE_GROUPED_RFM_MATRIX_DATA: "UPDATE_GROUPED_RFM_MATRIX_DATA",
  UPDATE_FREQUENCY_BAR_DATA: "UPDATE_FREQUENCY_BAR_DATA",
  UPDATE_FREQUENCY_TABLE_DATA: "UPDATE_FREQUENCY_TABLE_DATA",
  UPDATE_MONETARY_BAR_DATA: "UPDATE_MONETARY_BAR_DATA",
  UPDATE_MONETARY_TABLE_DATA: "UPDATE_MONETARY_TABLE_DATA",
  UPDATE_RECENCY_BAR_DATA: "UPDATE_RECENCY_BAR_DATA",
  UPDATE_RECENCY_TABLE_DATA: "UPDATE_RECENCY_TABLE_DATA",
  UPDATE_TOTAL_SPEND_BY_MONETARY_SCORE_DATA:
    "UPDATE_TOTAL_SPEND_BY_MONETARY_SCORE_DATA",
  UPDATE_ONE_TIME_VS_REPEAT_DATA: "UPDATE_ONE_TIME_VS_REPEAT_DATA",
};

export const TOPANDBOTTOMCUSTOMER = {
  GET_CUSTOMERS_ATRTRIBUTE: "GET_CUSTOMERS_ATRTRIBUTE",
  SORT_CUSTOMERS_ATRTRIBUTE: "SORT_CUSTOMERS_ATRTRIBUTE",
  GET_CUSTOMERS_ATRTRIBUTE_LIST: "GET_CUSTOMERS_ATRTRIBUTE_LIST",
  ACTIVE_STATUS_CUSTOMER_ATTRIBUTE: "ACTIVE_STATUS_CUSTOMER_ATTRIBUTE",
  UPDATE_CUSTOMERS_ATRTRIBUTE_LIST: "UPDATE_CUSTOMERS_ATRTRIBUTE_LIST",
};

export const AVAILABLEPLAYS = {
  GET_AVAILABLE_PLAYS: "GET_AVAILABLE_PLAYS",
  ACTIVATE_PLAY: "ACTIVATE_PLAY",
};

export const MARKETING_PLAY_REPORTS = {
  GET_ADHOC_REVENUE_BY_CLIENT_ID: "GET_ADHOC_REVENUE_BY_CLIENT_ID",
  GET_MARKETING_PLAYS_REVENUE_DETAIL: "GET_MARKETING_PLAYS_REVENUE_DETAIL",
  UPDATE_HEAT_MAP_DATA: "UPDATE_HEAT_MAP_DATA",
  GET_REVENUE_BY_CHANNEL: "GET_REVENUE_BY_CHANNEL",
  GET_TOTAL_ADHOC_REVENUE: "GET_TOTAL_ADHOC_REVENUE",
  GET_AVG_OPEN_EMAIL_RATE: "GET_AVG_OPEN_EMAIL_RATE",
  GET_PLAYS_REVENUE: "GET_PLAYS_REVENUE",
  GET_TOTAL_AND_REMAINING_TOUCHPOINTS: "GET_TOTAL_AND_REMAINING_TOUCHPOINTS",
  GET_CLIENT_PLAYS_WITH_TOTAL_REVENUE: "GET_CLIENT_PLAYS_WITH_TOTAL_REVENUE",
  GET_TOUCHPOINTS_WITH_REVENUE_BY_PLAY_ID:
    "GET_TOUCHPOINTS_WITH_REVENUE_BY_PLAY_ID",
  GET_TOUCHPOINTS_WITH_REVENUE_BY_CLIENT_ID:
    "GET_TOUCHPOINTS_WITH_REVENUE_BY_CLIENT_ID",
  GET_TOUCHPOINTS_WITH_REVENUE_BY_PLAY_ID_2:
    "GET_TOUCHPOINTS_WITH_REVENUE_BY_PLAY_ID_2",
  REVENUE_OVER_TIME_CUMULATIVE: "REVENUE_OVER_TIME_CUMULATIVE",
  REVENUE_OVER_TIME_MONTHLY: "REVENUE_OVER_TIME_MONTHLY",
  TOUCHPOINTS_WITH_REVENUE_INFO: "TOUCHPOINTS_WITH_REVENUE_INFO",
  PLAY_DETAILS_REVENUE_AVG_OPEN_RATE: "PLAY_DETAILS_REVENUE_AVG_OPEN_RATE",
  TOUCHPOINTS_CUMULATIVE_REVENUE_OVER_TIME:
    "TOUCHPOINTS_CUMULATIVE_REVENUE_OVER_TIME",
  TOUCHPOINTS_MONTHLY_REVENUE_OVER_TIME:
    "TOUCHPOINTS_MONTHLY_REVENUE_OVER_TIME",
  TOP_PLAYS_REVENUE: "TOP_PLAYS_REVENUE",
  GET_CLIENT_PLAYS_WITH_TOTAL_REVENUE_PLAY_DETAIL:
    "GET_CLIENT_PLAYS_WITH_TOTAL_REVENUE_PLAY_DETAIL",
  DESIGN_BY_TOUCHPONT_ID: "DESIGN_BY_TOUCHPONT_ID",
  GET_MANAGE_CAMPAIGN_SUMMARY: "GET_MANAGE_CAMPAIGN_SUMMARY",
  GET_MANAGE_CAMPAIGN_DETAIL: "GET_MANAGE_CAMPAIGN_DETAIL",
  GET_MANAGE_CAMPAIGN_DETAIL_ADHOC: "GET_MANAGE_CAMPAIGN_DETAIL_ADHOC",
};

export const MARKETINGPLAYCONFIGURATION = {
  LOAD_MARKETING_PLAY_LOOKUP: "LOAD_MARKETING_PLAY_LOOKUP",
  GET_TOUCHPOINTS_TEMPLATE_BY_PLAY_ID: "GET_TOUCHPOINTS_TEMPLATE_BY_PLAY_ID",
  SAVE_MARKETING_PLAY_WITH_TOUCHPOINTS: "SAVE_MARKETING_PLAY_WITH_TOUCHPOINTS",
  GET_ALL_PLAY_WITH_TOUCHPOINTS_BY_ClIENTID:
    "GET_ALL_PLAY_WITH_TOUCHPOINTS_BY_ClIENTID",
  GET_ALL_SCHEDULES_BY_ClIENTID: "GET_ALL_SCHEDULES_BY_ClIENTID",
  ENABLE_TOUCHPOINT: "ENABLE_TOUCHPOINT",
  GET_ALL_PLAY_WITH_TOUCHPOINTS_BY_PLAY_ID:
    "GET_ALL_PLAY_WITH_TOUCHPOINTS_BY_PLAY_ID",
  GET_ALL_PLAYS_CLIENT_ID: "GET_ALL_PLAYS_CLIENT_ID",
  REMOVE_PLAY_WITH_TOUCHPOINTS_FROM_STATE:
    "REMOVE_PLAY_WITH_TOUCHPOINTS_FROM_STATE",
  SAVE_TOUCHPOINT_SCHEDULE_MAPPING: "SAVE_TOUCHPOINT_SCHEDULE_MAPPING",
  UPDATE_TOUCHPOINT_SCHEDULE_MAPPING: "UPDATE_TOUCHPOINT_SCHEDULE_MAPPING",
  REMOVE_MARKETING_PLAY_BY_ID: "REMOVE_MARKETING_PLAY_BY_ID",
  GET_ALL_TOUCHPOINTS_BY_ClIENTID: "GET_ALL_TOUCHPOINTS_BY_ClIENTID",
  GET_ALL_PLAY_TOUCHPOINTS_REVENUE_MAPPINGS_BY_ClIENTID:
    "GET_ALL_PLAY_TOUCHPOINTS_REVENUE_MAPPINGS_BY_ClIENTID",
  GET_MAPPED_SCHEDULE_BY_PLAYID: "GET_MAPPED_SCHEDULE_BY_PLAYID",
};

export const COMMON = {
  COUNTS_FOR_PEOPLE_CUSTOMER_PROSPECT: "COUNTS_FOR_PEOPLE_CUSTOMER_PROSPECT",
  UPDATE_TOTAL_CONTACTS: "UPDATE_TOTAL_CONTACTS",
  RECENT_LOADS_UPDATE: "RECENT_LOADS_UPDATE",
  RECENT_SOURCES_UPDATE: "RECENT_SOURCES_UPDATE",
  DROP_DOWN_FILL: "DROP_DOWN_FILL",
  DROP_DOWN_CLICK: "DROP_DOWN_CLICK",
  GET_CLIENT: "GET_CLIENT",
  GET_USER: "GET_USER",
  PROVIDERS: "PROVIDERS",
  GET_CLIENT_LIST: "GET_CLIENT_LIST",
  GET_CLIENT_USER_CLAIMS: "GET_CLIENT_USER_CLAIMS",
  INCLUDE_CONGLOMS: "INCLUDE_CONGLOMS",
  MENU_CLICK_INFORMATION: "MENU_CLICK_INFORMATION",
  USER_MANAGEMENT: "USER_MANAGEMENT",
  INSERT_PORTAL_ACCESS_LOG: "INSERT_PORTAL_ACCESS_LOG",
  DESIGN_GUID: "DESIGN_GUID",
  GET_DEFUALT_VALUES : "GET_DEFUALT_VALUES"
};

export const EMAIL_DESIGNER = {
  HANDLE_TRACKING_PARAMETERS : "HANDLE_TRACKING_PARAMETERS",
  HANDLE_TRACKING_PARAMETERS_SELECTED_ITEM : "HANDLE_TRACKING_PARAMETERS_SELECTED_ITEM",
  UPDATE_IS_TRIGGERED_SEND_VALUE: "UPDATE_IS_TRIGGERED_BOOL_VALUE",
  Get_WEB_HOOK_DATA : "GET_WEB_HOOK_DATA",
  BEE_AUTH: "BEE_AUTH",
  BEE_UNSAVED_CHANGES: "BEE_UNSAVED_CHANGES",
  REMOVE_BEE_AUTH: "REMOVE_BEE_AUTH",
  GET_ALL_TEMPLATES: "GET_ALL_TEMPLATES",
  GET_STOCK_FOLDERS: "GET_STOCK_FOLDERS",
  GET_SHARE_FOLDERS: "GET_SHARE_FOLDERS",
  ON_SAVE_TEMPLATE: "ON_SAVE_TEMPLATE",
  ON_SAVE_DESIGN: "ON_SAVE_DESIGN",
  SEND_TEST_EMAIL: "SEND_TEST_EMAIL",
  SEED_LIST: "SEED_LIST", //NEED TO RENAME SEED_LIST.
  TEST_EMAIL_LIST: "TEST_EMAIL_LIST",
  GET_TEMPLATE_BY_ID: "GET_TEMPLATE_BY_ID",
  GET_TEMPLATE_DESIGN_VIEW_MODE: "GET_TEMPLATE_DESIGN_VIEW_MODE",
  GET_ALL_DESIGNS: "GET_ALL_DESIGNS",
  GET_DESIGN_BY_ID: "GET_DESIGN_BY_ID",
  DELETE_DESIGN: "DELETE_DESIGN",
  DELETE_TEMPLATE: "DELETE_TEMPLATE",
  GET_ALL_FOLDERS: "GET_ALL_FOLDERS",
  GET_ALL_TRACKING_PARAMS: "GET_ALL_TRACKING_PARAMS",
  GET_WEBHOOK_URL: "GET_WEBHOOK_URL",
  GET_ALL_MERGE_TAGS_FROM_DESIGN: "GET_ALL_MERGE_TAGS_FROM_DESIGN",
  GET_APPEND_TRACKING_PARAMS: "GET_APPEND_TRACKING_PARAMS",
  UNPUBLISH: "UNPUBLISH",
  PAUSE: "PAUSE",
  RESUME: "RESUME",
  DUPLICATE: "DUPLICATE",
  MOVE: "MOVE",
  RENAME: "RENAME",
  ARCHIVE: "ARCHIVE",
  ADD_FOLDER: "ADD_FOLDER",
  SUPPRESION_LIST: "SUPPRESION_LIST",
  AUDIENCE_CAMPAIGN_LIST: "AUDIENCE_CAMPAIGN_LIST",
  SEND_EMAIL: "SEND_EMAIL",
  ENABLE_WEBHOOK_TRIGGER: "ENABLE_WEBHOOK_TRIGGER",
  GET_ALL_FOLDERS_TREEVIEW: "GET_ALL_FOLDERS_TREEVIEW",
  GET_FROM_ADDRESSES: "GET_FROM_ADDRESSES",
  GET_REPLY_EMAIL_ADDRESSES: "GET_REPLY_EMAIL_ADDRESSES",
  GET_IMAGE_LIBRARY_CONTENTS: "GET_IMAGE_LIBRARY_CONTENTS",
  SELECTED_FOLDER_NAME: "SELECTED_FOLDER_NAME",
  UPLOAD_IMAGE: "UPLOAD_IMAGE",
  VALIDATE_UPLOAD: "VALIDATE_UPLOAD",
  DELETE_CONTENT: "DELETE_CONTENT",
  ADD_DIRECTORY: "ADD_DIRECTORY",
  REPLACE_IMAGE: "REPLACE_IMAGE",
  REPORT_OVERVIEW_EMAIL_SUMMARY: "REPORT_OVERVIEW_EMAIL_SUMMARY",
  REPORT_OVERVIEW_OPEN_AND_CLICK_RATE: "REPORT_OVERVIEW_OPEN_AND_CLICK_RATE",
  TOP_BOTTOM_PERFORMING_SUMMARY: "TOP_BOTTOM_PERFORMING_SUMMARY",
  DESIGN_COUNT_BY_CLIENT: "DESIGN_COUNT_BY_CLIENT",
  DESIGN_DROPDOWN_BY_CLIENT: "DESIGN_DROPDOWN_BY_CLIENT",
  DESIGN_EMAIL_DETAIL: "DESIGN_EMAIL_DETAIL",
  REPORT_SUBSCRIBER_TOP_LINKS: "REPORT_SUBSCRIBER_TOP_LINKS",
  REPORT_SUBSCRIBER_MOST_OPENS: "REPORT_SUBSCRIBER_MOST_OPENS",
  SUBSCRIBERS_DETAILS: "SUBSCRIBERS_DETAILS",
  TOUCHPOINT_MAPPING: "TOUCHPOINT_MAPPING",
  //SAVE_TOUCHPOINT_MAPPING: "SAVE_TOUCHPOINT_MAPPING",
  GET_ALL_IMAGE_LIBRARY_FOLDERS_TREEVIEW:
    "GET_ALL_IMAGE_LIBRARY_FOLDERS_TREEVIEW",
  GET_EXTERNAL_IMAGES: "GET_EXTERNAL_IMAGES",
  GET_EXTERNAL_CATEGORIES: "GET_EXTERNAL_CATEGORIES",
  SAVE_SCHEDULE: "SAVE_SCHEDULE",
  SCHEDULE_TRIGGERS: "SCHEDULE_TRIGGERS",
  DESIGN_BREADCRUMBS_ADD: "DESIGN_BREADCRUMBS_ADD",
  DESIGN_BREADCRUMBS_REMOVE: "DESIGN_BREADCRUMBS_REMOVE",
  TEMPLATE_BREADCRUMBS_ADD: "TEMPLATE_BREADCRUMBS_ADD",
  TEMPLATE_BREADCRUMBS_REMOVE: "TEMPLATE_BREADCRUMBS_REMOVE",
  TEMPLATE_BREADCRUMBS_REMOVE_ALL: "TEMPLATE_BREADCRUMBS_REMOVE_ALL",
  BEE_MERGE_TAGS: "BEE_MERGE_TAGS",
  MOVE_IMAGES: "MOVE_IMAGES",
  IMAGE_BREADCRUMBS_ADD: "IMAGE_BREADCRUMBS_ADD",
  IMAGE_BREADCRUMBS_REMOVE: "IMAGE_BREADCRUMBS_REMOVE",
  CLIENT_FONTS: "CLIENT_FONTS",
  CLIENT_COLORS: "CLIENT_COLORS",
  CLIENT_CONTENT_DEFAULTS: "CLIENT_CONTENT_DEFAULTS",
  BRAND_CONTENT_DEFAULTS: "BRAND_CONTENT_DEFAULTS",
  CLIENT_AI_TRAINING_HUB: "CLIENT_AI_TRAINING_HUB",
  DESIGN_SCHEDULE_TRIGGER: "DESIGN_SCHEDULE_TRIGGER",
  DESIGN_WEBHOOK_TRIGGER: "DESIGN_WEBHOOK_TRIGGER",
  DISABLED_SCHEDULED: "DISABLED_SCHEDULED",
  DISABLED_EDIT_SCHEDULED: "DISABLED_EDIT_SCHEDULED",
  REPORT_SENDS_PAGE: "REPORT_SENDS_PAGE",
  DYNAMICFIELDS: "DYNAMICFIELDS",
  CITIES: "CITIES",
  DYNAMIC_CONTENT_FIELDS: "DYNAMIC_CONTENT_FIELDS",
  GET_DESIGN_UPDATE_INTERVAL: "GET_DESIGN_UPDATE_INTERVAL",
  EXTERNAL_URL_VALIDATION: "EXTERNAL_URL_VALIDATION",
  SAVED_ROWS_CATEGORIES: "SAVED_ROWS_CATEGORIES",
  SAVED_ROWS: "SAVED_ROWS",
  ON_SAVE_ROW: "ON_SAVE_ROW",
  SAVE_ROW_VALIDATION: "SAVE_ROW_VALIDATION",
  DELETE_SAVED_ROW: "DELETE_SAVED_ROW",
  SEND_EMAIL_SEND_TO: "SEND_EMAIL_SEND_TO",
  SEND_EMAIL_FROM: "SEND_EMAIL_FROM",
  SEND_EMAIL_PROPERTIES: "SEND_EMAIL_PROPERTIES",
  SEND_EMAIL_SCHEDULE: "SEND_EMAIL_SCHEDULE",
  SEND_EMAIL_PLAY_TOUCHPOINT: "SEND_EMAIL_PLAY_TOUCHPOINT",
  SET_SEND_EMAIL_DETAILS: "SET_SEND_EMAIL_DETAILS",
  SET_ESP_USER_CREDIT: "SET_ESP_USER_CREDIT",
  LIST_SEND_FILE_VALIDATION: "LIST_SEND_FILE_VALIDATION",
  GET_DESIGN_PREVIEW: 'GET_DESIGN_PREVIEW',
  GET_DESIGN_PREVIEW_SUCCESS: 'GET_DESIGN_PREVIEW_SUCCESS',
  GET_DESIGN_PREVIEW_ERROR: 'GET_DESIGN_PREVIEW_ERROR',
  GET_DESIGN_ID_BY_PARTITION: 'GET_DESIGN_ID_BY_PARTITION',
  CLEAR_DESIGN_PREVIEW: 'CLEAR_DESIGN_PREVIEW',
  GENERATE_PUBLIC_PREVIEW_LINK: 'GENERATE_PUBLIC_PREVIEW_LINK',
  GENERATE_PUBLIC_PREVIEW_LINK_SUCCESS: 'GENERATE_PUBLIC_PREVIEW_LINK_SUCCESS',
  GENERATE_PUBLIC_PREVIEW_LINK_ERROR: 'GENERATE_PUBLIC_PREVIEW_LINK_ERROR',
  REVOKE_PUBLIC_PREVIEW_LINK: 'REVOKE_PUBLIC_PREVIEW_LINK',
  REVOKE_PUBLIC_PREVIEW_LINK_SUCCESS: 'REVOKE_PUBLIC_PREVIEW_LINK_SUCCESS',
  REVOKE_PUBLIC_PREVIEW_LINK_ERROR: 'REVOKE_PUBLIC_PREVIEW_LINK_ERROR',
  GET_PUBLIC_PREVIEW_LINK: 'GET_PUBLIC_PREVIEW_LINK',
  GET_PUBLIC_PREVIEW_LINK_SUCCESS: 'GET_PUBLIC_PREVIEW_LINK_SUCCESS',
  GET_PUBLIC_PREVIEW_LINK_ERROR: 'GET_PUBLIC_PREVIEW_LINK_ERROR',
  ABANDON_CART_SPECIAL_LINKS: 'ABANDON_CART_SPECIAL_LINKS',
  SURVEY_SPECIAL_LINKS: 'SURVEY_SPECIAL_LINKS',
  CLEAR_PUBLIC_PREVIEW_LINK: 'CLEAR_PUBLIC_PREVIEW_LINK',
  RELOAD_BEE_EDITOR : 'REFRESH_BEE_EDITOR',
  AI_GENERATE_DESIGN_REQUEST_START: 'AI_GENERATE_DESIGN_REQUEST_START',
  AI_GENERATE_DESIGN_REQUEST_STAGE_2: 'AI_GENERATE_DESIGN_REQUEST_STAGE_2',
  AI_GENERATE_DESIGN_REQUEST_SUCCESS: 'AI_GENERATE_DESIGN_REQUEST_SUCCESS',
  AI_GENERATE_DESIGN_REQUEST_ERROR: 'AI_GENERATE_DESIGN_REQUEST_ERROR',
  AI_FEEDBACK_SUBMIT_SUCCESS: 'AI_FEEDBACK_SUBMIT_SUCCESS',
  AI_FEEDBACK_SUBMIT_ERROR: 'AI_FEEDBACK_SUBMIT_ERROR',
  BEE_CHECK_REQUEST: 'BEE_CHECK_REQUEST',
  BEE_CHECK_SUCCESS: 'BEE_CHECK_SUCCESS',
  BEE_CHECK_ERROR: 'BEE_CHECK_ERROR',
  BEE_CHECK_CLEAR: 'BEE_CHECK_CLEAR'
};

export const SMS_DESIGNER = {
  EDITOR_STATE : "SET_AND_UPDATE_EDITOR_STATE",
  USER_SELECTED_MERGE_TAGS : "SET_USER_SELECTED_MERGE_TAGS",
  DELETE_USER_SELECTED_MERGE_TAG : "DELETE_USER_SELECTED_MERGE_TAG",
  IS_LIST_SEND : "IS_LIST_SEND_SELECTED",
  GET_ALL_MERGE_TAGS_FROM_SMS_DESIGN: "GET_ALL_MERGE_TAGS_FROM_SMS_DESIGN",
  GET_SMS_USER_CREDIT: "GET_SMS_USER_CREDIT",
  SELECTED_IMAGE: "SELECTED_IMAGE",
  GET_ALL_SMS_FOLDERS_TREEVIEW: "GET_ALL_SMS_FOLDERS_TREEVIEW",
  GET_ALL_FOLDERS: "GET_ALL_FOLDERS",
  ADD_FOLDER: "ADD_FOLDER",
  RENAME: "RENAME",
  ARCHIVE: "ARCHIVE",
  ON_SAVE_DESIGN: "ON_SAVE_DESIGN",
  GET_DESIGN_BY_ID: "GET_DESIGN_BY_ID",
  GET_SMS_UNSUBSCRIBETEXT_LIST: "GET_SMS_UNSUBSCRIBETEXT_LIST",
  MERGE_TAGS: "MERGE_TAGS",
  LIST_SEND_FILE_VALIDATION: "LIST_SEND_FILE_VALIDATION",
  AUDIENCE_CAMPAIGN_LIST: "AUDIENCE_CAMPAIGN_LIST",
  SEND_SMS_SEND_TO: "SEND_SMS_SEND_TO",
  SEND_SMS_FROM: "SEND_SMS_FROM",
  GET_DESIGN_SCHEDULE_TRIGGER: "GET_DESIGN_SCHEDULE_TRIGGER",
  UPDATE_DESIGN_SCHEDULE_TRIGGER: "UPDATE_DESIGN_SCHEDULE_TRIGGER",
  SEND_TEST_MESSAGE: "SEND_TEST_MESSAGE",
  RESUME: "RESUME",
  SEND_SMS: "SEND_SMS",
  // ENABLE_WEBHOOK_TRIGGER_SMS: "ENABLE_WEBHOOK_TRIGGER_SMS",
  PAUSE: "PAUSE",
  UNPUBLISH: "UNPUBLISH",
  DUPLICATE: "DUPLICATE",
  MOVE: "MOVE",
  DELETE_DESIGN: "DELETE_DESIGN",
  DISABLED_SCHEDULED: "DISABLED_SCHEDULED",
  AUTOMATED_COMPLIANCE_RESPONSE: "AUTOMATED_COMPLIANCE_RESPONSE",
  RESET_SMS_SEND_STATE: "RESET_SMS_SEND_STATE",
  GET_MONTHLY_SMS_CREDIT_USAGE: "GET_MONTHLY_SMS_CREDIT_USAGE",
  GET_DAILY_SMS_CREDIT_USAGE: "GET_DAILY_SMS_CREDIT_USAGE",
  DESIGN_DROPDOWN_BY_CLIENT: "DESIGN_DROPDOWN_BY_CLIENT",
  DESIGN_COUNT_BY_CLIENT: "DESIGN_COUNT_BY_CLIENT",
  REPORT_OVERVIEW_SMS_SUMMARY: "REPORT_OVERVIEW_SMS_SUMMARY",
  DESIGN_SMS_DETAIL: "DESIGN_SMS_DETAIL",
  SMS_SUMMARY_Monthly_Metrics: "SMS_SUMMARY_Monthly_Metrics",
  REPORT_SMS_DETAILS: "REPORT_SMS_DETAILS",
  REPORT_SMS_SUBSCRIBER_DETAILS: "REPORT_SMS_SUBSCRIBER_DETAILS",
  CREATE_SMS_KEYWORD: "CREATE_SMS_KEYWORD",
  GET_SMS_KEYWORD: "GET_SMS_KEYWORD",
  UPDATE_SMS_KEYWORD: "UPDATE_SMS_KEYWORD",
  ENABLE_SMS_KEYWORD: "ENABLE_SMS_KEYWORD",
  DISABLE_SMS_KEYWORD: "DISABLE_SMS_KEYWORD",
  GET_AUDIENCE_BY_FIELD_DATA: "GET_AUDIENCE_BY_FIELD_DATA",
  UPDATE_FOLDER_ID : "UPDATE_FOLDER_ID_FOR_SMS_DESIGNS_LANGDING_PAGE"
};

// redux/constants/action-types.js

export const TWO_FACTOR = {
  // Get enrolled methods
  GET_ENROLLED_METHODS: "GET_ENROLLED_METHODS",
  SET_ENROLLED_METHODS: "SET_ENROLLED_METHODS",
  
  // Email enrollment
  ENROLL_EMAIL_START: "ENROLL_EMAIL_START",
  ENROLL_EMAIL_SUCCESS: "ENROLL_EMAIL_SUCCESS",
  ENROLL_EMAIL_FAILURE: "ENROLL_EMAIL_FAILURE",
  
  // SMS enrollment
  ENROLL_SMS_START: "ENROLL_SMS_START",
  ENROLL_SMS_SUCCESS: "ENROLL_SMS_SUCCESS",
  ENROLL_SMS_FAILURE: "ENROLL_SMS_FAILURE",
  
  // Authenticator enrollment
  ENROLL_AUTH_APP_START: "ENROLL_AUTH_APP_START",
  ENROLL_AUTH_APP_SUCCESS: "ENROLL_AUTH_APP_SUCCESS",
  ENROLL_AUTH_APP_FAILURE: "ENROLL_AUTH_APP_FAILURE",
  GENERATE_QR_CODE: "GENERATE_QR_CODE",
  
  // Unenroll methods
  UNENROLL_METHOD_START: "UNENROLL_METHOD_START",
  UNENROLL_METHOD_SUCCESS: "UNENROLL_METHOD_SUCCESS",
  UNENROLL_METHOD_FAILURE: "UNENROLL_METHOD_FAILURE",

  DISABLE_TWO_FACTOR: "DISABLE_TWO_FACTOR",
  
  // General states
  SET_LOADING: "SET_LOADING",
  SET_ERROR: "SET_ERROR",
  CLEAR_ERROR: "CLEAR_ERROR",
  
  // Verification codes
  SEND_VERIFICATION_CODE: "SEND_VERIFICATION_CODE",
  VERIFY_CODE_SUCCESS: "VERIFY_CODE_SUCCESS",
  VERIFY_CODE_FAILURE: "VERIFY_CODE_FAILURE",
  
  // UI state
  SET_MODAL_OPEN: "SET_MODAL_OPEN",
  SET_MODAL_TYPE: "SET_MODAL_TYPE",
  SET_ENROLLMENT_STEP: "SET_ENROLLMENT_STEP"
};

export const MAX_FILE_SIZE = 100.0;
export const MAX_CHUNK_SIZE = 100000000;
export const MAX_UPLOAD_SIZE = 2048;

export const notificationType = {
  success: "success",
  error: "danger",
};

export const messageTypeEnum = {
  None: 0,
  Success: 1,
  Error: 2,
  Warning: 3,
  Info: 4,
  RequestOutOfDate: 5,
};

export const FORM_LIBRARY = {
  DESIGN_BREADCRUMBS_ADD: "DESIGN_BREADCRUMBS_ADD",
  DESIGN_BREADCRUMBS_REMOVE: "DESIGN_BREADCRUMBS_REMOVE",
  GET_ALL_CONTENT: "GET_ALL_CONTENT",
  ADD_FOLDER: "ADD_FOLDER",
  ARCHIVE: "ARCHIVE",
  RENAME: "RENAME",
  GET_ALL_FOLDERS_TREEVIEW: "GET_ALL_FOLDERS_TREEVIEW",
  MOVE: "MOVE",
  DRAG_EVENT: "DRAG_EVENT",
  SPECIAL_LINK: "SPECIAL_LINK",
  UPDATE_PROPERTIES: "UPDATE_PROPERTIES",
  GET_FORM_TEMPLATES_WITH_DETAILS: "GET_FORM_TEMPLATES_WITH_DETAILS",
};

export const FORM_EDITOR = {
  SAVE: "SAVE",
  GET_BY_ID: "GET_BY_ID",
  UPDATE: "UPDATE",
  GET_WEBHOOK_BY_CLIENT: "GET_WEBHOOK_BY_CLIENT",
  GET_FORM_FIELDS: "GET_FORM_FIELDS",
  GET_CONFIGURATIONS: "GET_CONFIGURATIONS",
  GET_EMBED_PAGE_DATA: "GET_EMBED_PAGE_DATA",
  UPDATE_FORM_DESIGN: "UPDATE_FORM_DESIGN",
};

export const FORM_SUBMISSIONS = {
  FORM_SUBMISSIONS_GET: "FORM_SUBMISSIONS_GET",
};

export const CUSTOMER = {
  CUSTOMER_LOOKUP_GET_RESULT: "CUSTOMER_LOOKUP_GET_RESULT",
  CUSTOMER_LOOKUP_SET_EMPTY: "CUSTOMER_LOOKUP_SET_EMPTY",
  CUSTOMER_LOOKUP_GET_DETAIL: "CUSTOMER_LOOKUP_GET_DETAIL",
  CUSTOMER_LOOKUP_UPDATE_DETAIL: "CUSTOMER_LOOKUP_UPDATE_DETAIL",

  CUSTOMER_LOOKUP_GET_WEB_HISTORY: "CUSTOMER_LOOKUP_GET_WEB_HISTORY",
  CUSTOMER_LOOKUP_GET_WEB_SUMMARY: "CUSTOMER_LOOKUP_GET_WEB_SUMMARY",

  CUSTOMER_LOOKUP_GET_EMAIL_HISTORY: "CUSTOMER_LOOKUP_GET_EMAIL_HISTORY",
  // V2 only. Separate from the above because its endpoint returns an envelope
  // (rows + freshness provenance) rather than a bare array, and Customer Lookup V1
  // plus the xlsx export still depend on the array shape.
  CUSTOMER_LOOKUP_GET_EMAIL_HISTORY_V2: "CUSTOMER_LOOKUP_GET_EMAIL_HISTORY_V2",
  CUSTOMER_LOOKUP_GET_CUSTOMER_PRODUCT_REG:
    "CUSTOMER_LOOKUP_GET_CUSTOMER_PRODUCT_REG",
  CUSTOMER_LOOKUP_GET_EMAIL_SUMMARY: "CUSTOMER_LOOKUP_GET_EMAIL_SUMMARY",

  CUSTOMER_LOOKUP_GET_TRANSACTION_HISTORY:
    "CUSTOMER_LOOKUP_GET_TRANSACTION_HISTORY",
  CUSTOMER_LOOKUP_GET_TRANSACTION_SUMMARY:
    "CUSTOMER_LOOKUP_GET_TRANSACTION_SUMMARY",

  CUSTOMER_LOOKUP_GET_RESERVATION_HISTORY:
    "CUSTOMER_LOOKUP_GET_RESERVATION_HISTORY",

  RESERVATION_HISTORY_COLUMNS_NAME: "RESERVATION_HISTORY_COLUMNS_NAME",
};

export const CALENDAR = {
  EVENT_QUERIES: "EVENT_QUERIES",
  EVENTS: "EVENTS",
  APPEND_EVENTS: "APPEND_EVENTS",
  CLEAR_EVENTS: "CLEAR_EVENTS",
  CAMPAIGN: "CAMPAIGN",
  CLEAR_CAMPAIGN: "CLEAR_CAMPAIGN",
  PROVIDER_EXPORT: "PROVIDER_EXPORT",
  CLEAR_PROVIDER_EXPORT: "CLEAR_PROVIDER_EXPORT",
  CLEAR_ALL: "CLEAR_ALL",
  PAGEREFRESH : "REFRESH_THE_CALENDER_PAGE_AFTER_SCHEDULING"
};

export const WIZARD = {
  UPDATE_CAMPAIGN_ID: "UPDATE_CAMPAIGN_ID",
  UPDATE_AUDIENCE_ID: "UPDATE_AUDIENCE_ID",
  UPDATE_DESIGN_ID: "UPDATE_DESIGN_ID",
  UPDATE_CAMPAIGN_AUDIENCE_DESIGN: "UPDATE_CAMPAIGN_AUDIENCE_DESIGN",
  UPDATE_CAMPAIGN_OLDDESIGN_ID: "UPDATE_CAMPAIGN_OLDDESIGN_ID",
  CLEAR_ALL_WIZARD: "CLEAR_ALL_WIZARD",
};

export const SURVEY = {
  // Designs & Folders
  GET_SURVEYS: "SURVEY_GET_SURVEYS",
  GET_FILTER_SURVEYS: "SURVEY_GET_FILTER_SURVEYS",
  GET_FOLDERS: "SURVEY_GET_FOLDERS",
  // Builder
  GET_SURVEY: "SURVEY_GET_SURVEY",
  GET_DEFINITION: "SURVEY_GET_DEFINITION",
  GET_THEME: "SURVEY_GET_THEME",
  GET_LINKS: "SURVEY_GET_LINKS",
  // Responses
  GET_RESPONSES: "SURVEY_GET_RESPONSES",
  GET_RESPONSE: "SURVEY_GET_RESPONSE",
  GET_SENTIMENT: "SURVEY_GET_SENTIMENT",
  SET_EXPORT_JOB: "SURVEY_SET_EXPORT_JOB",
  // Alerts
  GET_ALERTS: "SURVEY_GET_ALERTS",
  GET_ALERT_DETAIL: "SURVEY_GET_ALERT_DETAIL",
  GET_ALERT_COUNT: "SURVEY_GET_ALERT_COUNT",
  // Analytics
  GET_ANALYTICS: "SURVEY_GET_ANALYTICS",
  GET_QUESTION_FREQUENCY: "SURVEY_GET_QUESTION_FREQUENCY",
  GET_ALL_QUESTION_FREQUENCIES: "SURVEY_GET_ALL_QUESTION_FREQUENCIES",
  CLEAR_ANALYTICS: "SURVEY_CLEAR_ANALYTICS",
  // AI Chat
  GET_AI_SESSIONS: "SURVEY_GET_AI_SESSIONS",
  GET_AI_HISTORY: "SURVEY_GET_AI_HISTORY",
  SET_AI_SESSION: "SURVEY_SET_AI_SESSION",
  // Loading & error flags
  SET_SURVEYS_LOADING: "SURVEY_SET_SURVEYS_LOADING",
  SET_DEFINITION_LOADING: "SURVEY_SET_DEFINITION_LOADING",
  SET_SAVE_IN_PROGRESS: "SURVEY_SET_SAVE_IN_PROGRESS",
  SET_ERROR: "SURVEY_SET_ERROR",
  CLEAR_ERROR: "SURVEY_CLEAR_ERROR",
};
